// 宿泊予約フォームのチェックイン/チェックアウトの日付から泊数を計算する。
// フォーム送信時には「チェックイン日」と「泊数」のパラメータが必要なため。
$('form[name="reservationForm1"]').submit(function () {
  var target = $(this).children('input[name="le"]');
  var date1 = $(this).find("#datepicker1").val();
  var date2 = $(this).find("#datepicker2").val();
  var diff = getDiff(date1, date2);
  target.val(diff);
});
function getDiff(date1Str, date2Str) {
  var date1 = new Date(date1Str);
  var date2 = new Date(date2Str);
  // まずミリ秒での差を求めてそれを日数に変換する
  var msDiff = date2.getTime() - date1.getTime();
  var daysDiff = Math.floor(msDiff / (1000 * 60 * 60 * 24));
  return daysDiff;
}

// レストラン予約フォームにおいて選択したレストラン名に応じて
// フォーム送信先（TableCheckの予約システム）のURLを変更する。
// TableCheckのURLはつぎのような形式。○○○に店舗名が入る。
// https://www.tablecheck.com/shops/○○○/reserve
$('select[name="restaurant"]').on('change', function () {
  var target = $(this).closest('form');
  var selectedShopName = $(this).val();
  var baseUrl = "https://www.tablecheck.com/shops/__SHOP__/reserve";
  var formUrl = baseUrl.replace('__SHOP__', selectedShopName);
  target.attr('action', formUrl);
});

// レストラン予約フォームの選択日時からUNIXタイムを計算して
// フォームのhiddenパラメータとして設定する。
// TableCheckの仕様としてフォーム送信時にUNIXタイム（秒単位）で送信する必要があるため。
// $('form[name="reservationForm2"]').submit(function () {
//   const target = $(this).children('input[name="start_at_epoch"]');
//   const timeStr = $(this).find('select[name="epoch"]').val();
//   const dateStr = $(this).find('input[name="start_date"]').val();
//   const date = new Date(dateStr + ' ' + timeStr);
//   const epoch = Math.floor(date.getTime() / 1000);
//   target.val(epoch);
// });

// SP表示の際に「デイユースプラン一覧」のリンク先URLを変更する
// ※予約フォームは全ページに存在するので、判定などはとくに必要無し
$(window).on('load, resize', function () {
  var width = window.innerWidth;
  if (width < 768) {
    $('a:contains("デイユースプラン一覧")').each(function () {
      $(this).attr('href', 'https://secure.reservation.jp/okura-jalhotels/s_sp/rsv/plan_list.aspx?hi_id=29&lang=ja-JP&img_view=True&du=1');
    });
  }
});